import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { TabView, TabPanel } from 'primereact/tabview';
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputSwitch } from 'primereact/inputswitch';
import { Editor } from 'primereact/editor';
import { InputTextarea } from 'primereact/inputtextarea';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from 'primereact/dropdown';
import { MedicineLeafletTypes } from '../../../common/enums';
import * as Constants from '../../../common/constants';
import { DropdownModel } from '../../../models/dropdownModel';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import Translate from '../../../common/functions/translate';
import { FileModel } from "../../../models/fileModel";
import { ImportEmaMedicineModel } from "../../../models/dataSynchronization";
import { ImportAdminMedicineModel } from "../../../models/dataSynchronization";
import { ManufacturerAdminModel } from "../../../models/manufacturer";
import { ATCCodeModel } from '../../../models/atcCode';
import DataSyncService from '../../../services/dataSyncService';
import { Lang } from '../../../common/enums';
import Language from '../../../common/components/language/language';
import { Fieldset } from 'primereact/fieldset';
import { Card } from 'primereact/card';
import InactiveAddEditDialog from './inactiveAddEditDialog';
import { InactiveIngredientAdminModel } from "../../../models/inactiveIngredient";
import { InactiveIngredientContentModel } from '../../../models/inactiveIngredient/inactiveIngredientContentModel';
import { array } from 'prop-types';
import { ManufacturerContentModel } from '../../../models/manufacturer/manufacturerContentModel';
import { DosageContentContentModel } from '../../../models/dosage/dosageContentContentModel';
import { IngredientSideEffectContentModel } from '../../../models/sideEffect/ingredientSideEffectContentModel';
import { PregnancyAndBreastfeedingContentModel } from '../../../models/medicine/pregnancyAndBreastfeedingContentModel';
import { DriveAndMachineContentModel } from '../../../models/medicine/driveAndMachineContentModel';
import { SafetyDataContentModel } from '../../../models/medicine/safetyDataContentModel';
import { MedicineInteractionContentModel } from '../../../models/medicine/medicineInteractionContentModel';
import { DosageContentModel } from '../../../models/dosage';
import { DriveAndMachineModel, PregnancyAndBreastfeedingModel } from '../../../models/medicine';
import { SafetyDataModel } from '../../../models/medicine/safetyDataModel';
import { IngredientSideEffectModel } from '../../../models/sideEffect';

interface IProps {
  syncClick: any,
  updateClick: any,
  cancelClick: any,
  isVisible: boolean,
  currentImportedMedicine: ImportEmaMedicineModel
  currentAdminMedicine: ImportAdminMedicineModel
}

interface IState {
  currentImportedMedicine: ImportEmaMedicineModel,
  currentAdminMedicine: ImportAdminMedicineModel,
  validationMessage: string,
  inputMedicineFiles: Array<FileModel>;
  leafletTypes: Array<DropdownModel>;
  selectedLangId: number;
  activeIndex: number;
  isVisibleInactiveAddEdit: boolean;
  currentInactiveIngredient: InactiveIngredientAdminModel;
  currentInactiveIndex: number
}

class ImportDataEditDialog extends React.Component<IProps, IState> {
  dataSyncService = new DataSyncService();
  op: any;
  scrollRef: any;

  constructor(props: IProps) {
    super(props);

    let leafletTypes = HelperFunctions.enumToDropdownArray(MedicineLeafletTypes)
      .map(t => { return { value: t.value, label: Translate(t.label) } });

    if (!props.currentAdminMedicine.leafletIds) {
      props.currentAdminMedicine.leafletIds = new Array<number>(0);
    }

    if (!props.currentAdminMedicine.medicineInteractionContents) {
      props.currentAdminMedicine.medicineInteractionContents = new Array<MedicineInteractionContentModel>(0);
    }

    if (!props.currentAdminMedicine.dosageContent) {
      props.currentAdminMedicine.dosageContent = new DosageContentModel();
      props.currentAdminMedicine.dosageContent.dosageContentContent = new Array<DosageContentContentModel>(0);
    }

    if (!props.currentAdminMedicine.driveAndMachine) {
      props.currentAdminMedicine.driveAndMachine = new DriveAndMachineModel();
      props.currentAdminMedicine.driveAndMachine.driveAndMachineContent = new Array<DriveAndMachineContentModel>(0);
    }

    if (!props.currentAdminMedicine.pregnancyAndBreastfeeding) {
      props.currentAdminMedicine.pregnancyAndBreastfeeding = new PregnancyAndBreastfeedingModel();
      props.currentAdminMedicine.pregnancyAndBreastfeeding.pregnancyAndBreastfeedingContent = new Array<PregnancyAndBreastfeedingContentModel>(0);
    }

    if (!props.currentAdminMedicine.safetyData) {
      props.currentAdminMedicine.safetyData = new SafetyDataModel();
      props.currentAdminMedicine.safetyData.safetyDataContent = new Array<SafetyDataContentModel>(0);
    }

    if (!props.currentAdminMedicine.sideEffect) {
      props.currentAdminMedicine.sideEffect = new IngredientSideEffectModel();
      props.currentAdminMedicine.sideEffect.ingredientSideEffectContent = new Array<IngredientSideEffectContentModel>(0);
    }

    this.state = {
      currentImportedMedicine: props.currentImportedMedicine,
      currentAdminMedicine: props.currentAdminMedicine,
      validationMessage: '',
      leafletTypes: leafletTypes,
      inputMedicineFiles: new Array<FileModel>(),
      selectedLangId: Lang.bg,
      activeIndex: 0,
      isVisibleInactiveAddEdit: false,
      currentInactiveIngredient: new InactiveIngredientAdminModel(),
      currentInactiveIndex: -1
    };

    this.scrollRef = React.createRef();
  }

  componentDidMount() {
    if (this.state.currentImportedMedicine.importEmaMedicineContents) {
      this.state.currentImportedMedicine.importEmaMedicineContents.map(f => {
        if (f.leafletFileView) {
          this.state.inputMedicineFiles.push(f.leafletFileView)
        }
        if (f.smPCFileView) {
          this.state.inputMedicineFiles.push(f.smPCFileView)
        }
        if (f.eparFileView) {
          this.state.inputMedicineFiles.push(f.eparFileView)
        }
      })
    }
  }

  handleChangeAdmin = (key, value) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    currentAdminMedicine[key] = value;
    this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
  };

  getAdminContentValue = (key) => {
    let content = this.state.currentAdminMedicine.adminMedicineContents.find(r => r.langId == this.state.selectedLangId);
    if (content && content[key]) {
      return content[key];
    }
    return '';
  }

  //TODO: if lang item missing add else and push to content array. See other methods below.
  handleChangeAdminContent = (key, value) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    let content = currentAdminMedicine.adminMedicineContents.find(r => r.langId == this.state.selectedLangId)
    if (content) {
      content[key] = value;
      this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
    }
  };

  handleSyncToDBButton = (event, close) => {
  }

  handleUpdateMedicineButton = (event, close) => {
    event.preventDefault();

    if (this.state.inputMedicineFiles) {
      let leaflets = this.state.inputMedicineFiles;
      let currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };

      leaflets.forEach(element => {
        currentAdminMedicine.leafletIds.push(element.fileId)
      });

      this.setState({ currentAdminMedicine: currentAdminMedicine });
    }

    this.props.updateClick(this.state.currentAdminMedicine, close);
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  onLangChange = (lang) => {
    this.setState({ selectedLangId: lang }, this.checkIndexes);
  }

  checkIndexes = () => {
    const index = this.state.activeIndex;
    if (index == 1 || index == 2 || index == 3 || index == 4) {
      setTimeout(() => {
        this.setState({ activeIndex: 100 }, () => {
          this.setState({ activeIndex: index })
        });
      });
    }
  }

  getImportedContentValue = (key) => {
    let content = this.state.currentImportedMedicine.importEmaMedicineContents.find(r => r.langId == this.state.selectedLangId)
    if (content && content[key]) {
      return content[key];
    }
    return '';
  }

  getInactiveImportedContentValue = (key) => {
    let content = this.state.currentImportedMedicine.importEmaMedicineContents.find(r => r.langId == this.state.selectedLangId)
    if (content && content[key]) {
      return content[key];
    }
    return '';
  }

  getManufacturerContentValue = (key) => {
    let manufacturer = this.state.currentAdminMedicine.manufacturer;
    if (manufacturer && manufacturer.manufacturerContent && manufacturer.manufacturerContent.length > 0) {
      let content = manufacturer.manufacturerContent.find(r => r.langId == this.state.selectedLangId)
      if (content && content[key]) {
        return content[key];
      }
      return '';
    }
    return '';
  }

  handleChangeManufacturerContent = (key, value) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    let manufacturer = currentAdminMedicine.manufacturer;
    if (manufacturer && manufacturer.manufacturerContent) {
      let content = manufacturer.manufacturerContent.find(r => r.langId == this.state.selectedLangId)
      if (content) {
        content[key] = value;
      } else {
        content = new ManufacturerContentModel();
        content.langId = this.state.selectedLangId;
        content[key] = value;

        manufacturer.manufacturerContent.push(content);
      }
      this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
    }
  };

  getAuthHolderContentValue = (key) => {
    let authorizationHolder = this.state.currentAdminMedicine.authorizationHolder;
    if (authorizationHolder && authorizationHolder.manufacturerContent && authorizationHolder.manufacturerContent.length > 0) {
      let content = authorizationHolder.manufacturerContent.find(r => r.langId == this.state.selectedLangId);
      if (content && content[key]) {
        return content[key];
      }
      return '';
    }
    return '';

    // const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };

    // let authorizationHolder = currentAdminMedicine.authorizationHolder;
    // if (authorizationHolder && authorizationHolder.manufacturerContent && authorizationHolder.manufacturerContent.length > 0) {

    //   let debug = authorizationHolder.manufacturerContent[0];
    //   if (!debug) {
    //     authorizationHolder.manufacturerContent.splice(key, 1);

    //     let content = new ManufacturerContentModel();
    //     content.langId = this.state.selectedLangId;

    //     authorizationHolder.manufacturerContent.push(content);

    //     this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
    //   }

    // }
    // return ''
  }

  handleChangeAuthHolderContent = (key, value) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    let authorizationHolder = currentAdminMedicine.authorizationHolder;
    if (authorizationHolder && authorizationHolder.manufacturerContent) {
      let content = authorizationHolder.manufacturerContent.find(r => r.langId == this.state.selectedLangId)
      if (content) {
        content[key] = value;
      }
      else {
        content = new ManufacturerContentModel();
        content.langId = this.state.selectedLangId;
        content[key] = value;

        authorizationHolder.manufacturerContent.push(content);
      }
      this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
    }
  };

  showInactiveAddEditDialog = (show: boolean) => {
    this.setState({
      isVisibleInactiveAddEdit: show
    });
  };

  handleSaveInactiveButton = (currentInactiveIngredient: InactiveIngredientAdminModel) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    if (this.state.currentInactiveIndex < 0) {
      currentAdminMedicine.inactiveIngredients.push(currentInactiveIngredient);
    } else {
      currentAdminMedicine.inactiveIngredients[this.state.currentInactiveIndex] = currentInactiveIngredient
    }

    this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
    this.showInactiveAddEditDialog(false);
  };

  handleInactiveCancelButton = () => {
    this.showInactiveAddEditDialog(false);
  };

  setcurrentInactiveIngredient(inactiveIngredient: InactiveIngredientAdminModel) {
    this.setState({ currentInactiveIngredient: { ...inactiveIngredient } });
  }

  handleInactiveAddEditClick = (currentInactiveIngredient: InactiveIngredientAdminModel, key: any) => {
    this.setState({ currentInactiveIndex: key });
    if (key < 0) {
      currentInactiveIngredient.inactiveIngredientContent = new Array<InactiveIngredientContentModel>(0)
      let bgContent = new InactiveIngredientContentModel();
      bgContent.langId = 1;
      currentInactiveIngredient.inactiveIngredientContent.push(bgContent);

      let enContent = new InactiveIngredientContentModel();
      enContent.langId = 2;
      currentInactiveIngredient.inactiveIngredientContent.push(enContent);
    }
    this.setcurrentInactiveIngredient(currentInactiveIngredient);
    this.showInactiveAddEditDialog(true);
  };

  handleInactiveDeleteClick = (key: any) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    currentAdminMedicine.inactiveIngredients.splice(key, 1);

    this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
  };

  getDosageContentValue = (key) => {
    let dosage = this.state.currentAdminMedicine.dosageContent;
    if (dosage && dosage.dosageContentContent) {
      let content = dosage.dosageContentContent.find(r => r.langId == this.state.selectedLangId);
      if (content && content[key]) {
        return content[key];
      }
      return '';
    }
  }

  handleChangeDosageContent = (key, value) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    let dosage = currentAdminMedicine.dosageContent;
    if (dosage && dosage.dosageContentContent) {
      let content = dosage.dosageContentContent.find(r => r.langId == this.state.selectedLangId)
      if (content) {
        content[key] = value;
      }
      else {
        content = new DosageContentContentModel();
        content.langId = this.state.selectedLangId;
        content[key] = value;

        dosage.dosageContentContent.push(content);
      }
      this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
    }
  };

  getSideEffectContentValue = (key) => {
    let sideEffect = this.state.currentAdminMedicine.sideEffect;
    if (sideEffect && sideEffect.ingredientSideEffectContent) {
      let content = sideEffect.ingredientSideEffectContent.find(r => r.langId == this.state.selectedLangId);
      if (content && content[key]) {
        return content[key];
      }
      return '';
    }
  }

  handleChangeSideEffectContent = (key, value) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    let sideEffect = currentAdminMedicine.sideEffect;
    if (sideEffect && sideEffect.ingredientSideEffectContent) {
      let content = sideEffect.ingredientSideEffectContent.find(r => r.langId == this.state.selectedLangId)
      if (content) {
        content[key] = value;
      }
      else {
        content = new IngredientSideEffectContentModel();
        content.langId = this.state.selectedLangId;
        content[key] = value;

        sideEffect.ingredientSideEffectContent.push(content);
      }
      this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
    }
  };

  getMedicineInteractionContentValue = (key) => {
    let content = this.state.currentAdminMedicine.medicineInteractionContents.find(r => r.langId == this.state.selectedLangId);
    if (content && content[key]) {
      return content[key];
    }
    return '';
  }

  handleChangeMedicineInteractionContent = (key, value) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    let content = currentAdminMedicine.medicineInteractionContents.find(r => r.langId == this.state.selectedLangId)
    if (content) {
      content[key] = value;
    }
    else {
      content = new MedicineInteractionContentModel();
      content.langId = this.state.selectedLangId;
      content[key] = value;

      currentAdminMedicine.medicineInteractionContents.push(content);
    }
    this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
  };

  getPregnancyContentValue = (key) => {
    let pregnancy = this.state.currentAdminMedicine.pregnancyAndBreastfeeding;
    if (pregnancy && pregnancy.pregnancyAndBreastfeedingContent) {
      let content = pregnancy.pregnancyAndBreastfeedingContent.find(r => r.langId == this.state.selectedLangId);
      if (content && content[key]) {
        return content[key];
      }
      return '';
    }
    return ''
  }

  handleChangePregnancyContent = (key, value) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    let pregnancy = currentAdminMedicine.pregnancyAndBreastfeeding;
    if (pregnancy && pregnancy.pregnancyAndBreastfeedingContent) {
      let content = pregnancy.pregnancyAndBreastfeedingContent.find(r => r.langId == this.state.selectedLangId)
      if (content) {
        content[key] = value;
      }
      else {
        content = new PregnancyAndBreastfeedingContentModel();
        content.langId = this.state.selectedLangId;
        content[key] = value;

        pregnancy.pregnancyAndBreastfeedingContent.push(content);
      }
      this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
    }
  };

  getDriveContentValue = (key) => {
    let drive = this.state.currentAdminMedicine.driveAndMachine;
    if (drive && drive.driveAndMachineContent) {
      let content = drive.driveAndMachineContent.find(r => r.langId == this.state.selectedLangId);
      if (content && content[key]) {
        return content[key];
      }
      return '';
    }
    return ''
  }

  handleChangeDriveContent = (key, value) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    let drive = currentAdminMedicine.driveAndMachine;
    if (drive && drive.driveAndMachineContent) {
      let content = drive.driveAndMachineContent.find(r => r.langId == this.state.selectedLangId)
      if (content) {
        content[key] = value;
      }
      else {
        content = new DriveAndMachineContentModel();
        content.langId = this.state.selectedLangId;
        content[key] = value;

        drive.driveAndMachineContent.push(content);
      }
      this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
    }
  };

  getSafetyDataContentValue = (key) => {
    let safetyData = this.state.currentAdminMedicine.safetyData;
    if (safetyData && safetyData.safetyDataContent) {
      let content = safetyData.safetyDataContent.find(r => r.langId == this.state.selectedLangId);
      if (content && content[key]) {
        return content[key];
      }
      return '';
    }
    return ''
  }

  handleChangeSafetyDataContent = (key, value) => {
    const currentAdminMedicine: ImportAdminMedicineModel = { ...this.state.currentAdminMedicine };
    let safetyData = currentAdminMedicine.safetyData;
    if (safetyData && safetyData.safetyDataContent) {
      let content = safetyData.safetyDataContent.find(r => r.langId == this.state.selectedLangId)
      if (content) {
        content[key] = value;
      }
      else {
        content = new SafetyDataContentModel();
        content.langId = this.state.selectedLangId;
        content[key] = value;

        safetyData.safetyDataContent.push(content);
      }
      this.setState({ currentAdminMedicine: { ...currentAdminMedicine } });
    }
  };

  public render() {
    const { currentImportedMedicine, inputMedicineFiles, currentAdminMedicine, selectedLangId } = this.state;

    let header = currentAdminMedicine.brandName ? currentAdminMedicine.brandName : '';

    if (currentAdminMedicine && currentAdminMedicine.adminMedicineContents && currentAdminMedicine.adminMedicineContents.length > 0) {
      let title = currentAdminMedicine.adminMedicineContents.find(m => m.langId == selectedLangId);
      if (title) {
        header = header + ' - ' + title.additionalTitle;
      }
    }

    return (
      <>
        <Dialog
          header={header}
          responsive={true}
          width="80%"
          modal={true}
          visible={this.props.isVisible}
          onHide={this.handleCancelButton}
          footer={
            <div>
              {/* <Button label="Synchronize to DB" icon="pi pi-check" onClick={(e) => this.handleSyncToDBButton(e, true)} className="p-button-success p-button-raised" /> */}
              <Button label="Save" icon="pi pi-save" onClick={(e) => this.handleUpdateMedicineButton(e, false)} className="p-button-raised" />
              <Button label="Save & Close" icon="pi pi-check" onClick={(e) => this.handleUpdateMedicineButton(e, true)} className="p-button-success p-button-raised" />
              <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
            </div>}
        >
          <div style={{ minHeight: '650px', maxHeight: '700px', overflowY: 'auto' }} ref={this.scrollRef}>

            {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
            <div style={{ maxWidth: 70 }}>
              <Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
            </div>
            <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index }, () => {
              if (this.scrollRef) {
                this.scrollRef.current.scrollTop = 0;
              }
            })}>
              <TabPanel header="Basic info">
                <div className="p-fluid p-grid p-md-12">
                  <div className="p-col-12 p-md-3" >
                    <label><strong>Brand Name</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(EMA Excel)</label>
                    <InputText
                      name="brandName"
                      onChange={(e) => this.handleChangeAdminContent('brandName', e.target['value'])}
                      value={this.getAdminContentValue('brandName')}
                    />
                  </div>
                  <div className="p-col-12 p-md-3" >
                    <label><strong>EMA Product number</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(EMA Excel)</label>
                    <InputText
                      name="emaProductNumber"
                      onChange={(e) => this.handleChangeAdmin('emaProductNumber', e.target['value'])}
                      value={currentAdminMedicine && currentAdminMedicine.emaProductNumber ? currentAdminMedicine.emaProductNumber : ""}
                    />
                  </div>
                  <div className="p-col-12 p-md-3">
                    <label><strong>EMA Medicine URL</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(EMA Excel)</label>
                    <InputText
                      name="emaMedicineURL"
                      onChange={(e) => this.handleChangeAdmin('emaMedicineURL', e.target['value'])}
                      value={currentAdminMedicine && currentAdminMedicine.emaMedicineURL ? currentAdminMedicine.emaMedicineURL : ""}
                    />
                  </div>
                  <div className="p-col-12 p-md-3" >
                    <label><strong>Medicine ATC Code</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(EMA Excel)</label>
                    <div className="p-inputgroup">
                      <InputText
                        value={currentAdminMedicine && currentAdminMedicine.atcCode ? currentAdminMedicine.atcCode.atcCode : ""}
                        readOnly={true}
                      />
                      <Button
                        icon="pi pi-plus"
                        className="p-button-success"
                      />
                      <Button
                        icon="pi pi-times-circle"
                        className="p-button-warning"
                      />
                    </div>
                  </div>
                  <div className="p-col-12 p-md-12">
                    <label><strong>Title</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - заглавие)</label>
                    <InputTextarea
                      name="additionalTitle"
                      rows={3}
                      style={{ width: '100%' }}
                      onChange={(e) => this.handleChangeAdminContent('additionalTitle', e.target['value'])}
                      value={this.getAdminContentValue('additionalTitle')}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <DataTable
                      header="Active ingredients"
                      value={currentAdminMedicine.activeIngredients}
                    >
                      <Column field="genericINNName" header="Generic name" />
                      <Column field="activeIngredientName" header="Active ingredient name" />
                      <Column
                        header="Actions"
                        style={{ textAlign: "center", width: "8em" }}
                        body={(rowData, column) =>
                          <div>
                            <Button
                              type="button"
                              icon="pi pi-pencil"
                              className="p-button-warning"
                              tooltip="Edit"
                              tooltipOptions={{ position: 'top' }}
                              style={{ marginRight: ".5em" }}
                            />
                            <Button
                              type="button"
                              icon="pi pi-trash"
                              className="p-button-danger"
                              tooltip="Remove"
                              tooltipOptions={{ position: 'top' }}
                            />
                          </div>
                        }
                      />
                    </DataTable>
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label>Imported Inactive ingredients</label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - от точка 6)</label>
                    <InputTextarea
                      name="inactiveIngredientsContent"
                      rows={3}
                      style={{ width: '100%' }}
                      readOnly={true}
                      value={this.getInactiveImportedContentValue('inactiveIngredientsContent')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label><strong>Inactive ingredients content</strong></label>
                    <InputTextarea
                      name="inactiveIngredientsContent"
                      rows={3}
                      style={{ width: '100%' }}
                      onChange={(e) => this.handleChangeAdminContent('inactiveIngredientsContent', e.target['value'])}
                      value={this.getAdminContentValue('inactiveIngredientsContent')}
                    />
                  </div>
                  {/* <div className="p-col-12 p-md-12">
                    <label><strong>Inactive content BG</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - от точка 6)</label>
                    <InputTextarea
                      rows={3}
                      name="inactiveSubstances"
                      readOnly={true}
                      value={this.getInactiveImportedContentValue('inactiveSubstances', 1)}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <label><strong>Inactive content EN</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - от точка 6)</label>
                    <InputTextarea
                      rows={3}
                      name="inactiveSubstances"
                      readOnly={true}
                      value={this.getInactiveImportedContentValue('inactiveSubstances', 2)}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <div className="mb-2">
                      <button
                        onClick={() => this.handleInactiveAddEditClick(new InactiveIngredientAdminModel(), -1)}
                        className="btn btn-success"
                        style={{ marginRight: "5px" }}>
                        Add New Inactive
                      </button>
                    </div>
                    <DataTable
                      header="Medicine inactive ingredients"
                      value={currentAdminMedicine.inactiveIngredients}
                    >
                      <Column field="name" header="Inactive substance name"
                        body={(rowData, column) =>
                          rowData && rowData.inactiveIngredientContent && rowData.inactiveIngredientContent.length ?
                            rowData.inactiveIngredientContent
                              .filter(x => typeof x.name === 'string' && x.name.length > 0)
                              .map(r => r.name)
                              .join(' / ')
                            : null
                        }
                      />
                      <Column
                        header="Actions"
                        style={{ textAlign: "center", width: "8em" }}
                        body={(rowData, column) =>
                          <div>
                            <Button
                              type="button"
                              icon="pi pi-pencil"
                              className="p-button-warning"
                              tooltip="Edit"
                              tooltipOptions={{ position: 'top' }}
                              style={{ marginRight: ".5em" }}
                              onClick={() => this.handleInactiveAddEditClick(rowData, currentAdminMedicine.inactiveIngredients.indexOf(rowData))}
                            />
                            <Button
                              type="button"
                              icon="pi pi-trash"
                              className="p-button-danger"
                              tooltip="Remove"
                              tooltipOptions={{ position: 'top' }}
                              onClick={() => this.handleInactiveDeleteClick(currentAdminMedicine.inactiveIngredients.indexOf(rowData))}
                            />
                          </div>
                        }
                      />
                    </DataTable>
                  </div> */}
                  <div className="p-col-12 p-md-6">
                    <Card title="Authorisation Holder">
                      <div className="p-fluid p-grid p-md-12">
                        <div className="p-col-12 p-md-12">
                          <label style={{ color: "#dc3545" }}>&nbsp;(ЛП - от точка 6)</label>
                          <InputTextarea
                            rows={5}
                            name="leafletAuthorisationHolder"
                            readOnly={true}
                            value={this.getImportedContentValue('leafletAuthorisationHolder')}
                          />
                        </div>
                        <div className="p-col-12 p-md-12">
                          <label><strong>Name</strong></label>
                          <InputText
                            name="name"
                            onChange={(e) => this.handleChangeAuthHolderContent('name', e.target['value'])}
                            value={this.getAuthHolderContentValue("name")}
                          />
                        </div>
                        <div className="p-col-12 p-md-12">
                          <label><strong>Full address</strong></label>
                          <InputTextarea
                            name="address"
                            rows={3}
                            onChange={(e) => this.handleChangeAuthHolderContent('address', e.target['value'])}
                            value={this.getAuthHolderContentValue("address")}
                          />
                        </div>
                        {/* <div className="p-col-12 p-md-6">
                          <label><strong>City</strong></label>
                          <InputText
                            name="city"
                            onChange={(e) => this.handleChangeAuthHolderContent('city', e.target['value'])}
                            value={this.getAuthHolderContentValue("city")}
                          />
                        </div>
                        <div className="p-col-12 p-md-6">
                          <label><strong>Country</strong></label>
                          <InputText
                            name="country"
                            onChange={(e) => this.handleChangeAuthHolderContent('country', e.target['value'])}
                            value={this.getAuthHolderContentValue("country")}
                          />
                        </div> */}
                      </div>
                    </Card>
                  </div>
                  <div className="p-col-12 p-md-6">
                    <Card title="Manufacturer">
                      <div className="p-fluid p-grid p-md-12">
                        <div className="p-col-12 p-md-12">
                          <label style={{ color: "#dc3545" }}>&nbsp;(ЛП - от точка 6)</label>
                          <InputTextarea
                            rows={5}
                            name="leafletManufacturer"
                            readOnly={true}
                            value={this.getImportedContentValue('leafletManufacturer')}
                          />
                        </div>
                        <div className="p-col-12 p-md-12">
                          <label><strong>Name</strong></label>
                          <InputText
                            name="name"
                            onChange={(e) => this.handleChangeManufacturerContent('name', e.target['value'])}
                            value={this.getManufacturerContentValue("name")}
                          />
                        </div>
                        <div className="p-col-12 p-md-12">
                          <label><strong>Full address</strong></label>
                          <InputTextarea
                            name="address"
                            rows={3}
                            onChange={(e) => this.handleChangeManufacturerContent('address', e.target['value'])}
                            value={this.getManufacturerContentValue("address")}
                          />
                        </div>
                        {/* <div className="p-col-12 p-md-6">
                          <label><strong>City</strong></label>
                          <InputText
                            name="city"
                            onChange={(e) => this.handleChangeManufacturerContent('city', e.target['value'])}
                            value={this.getManufacturerContentValue("city")}
                          />
                        </div>
                        <div className="p-col-12 p-md-6">
                          <label><strong>Country</strong></label>
                          <InputText
                            name="country"
                            onChange={(e) => this.handleChangeManufacturerContent('country', e.target['value'])}
                            value={this.getManufacturerContentValue("country")}
                          />
                        </div> */}
                      </div>
                    </Card>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Overview">
                <div className="p-grid p-fluid p-md-12">
                  <div className="p-col-12 p-md-6">
                    <label>Imported Summary</label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - между заглавие и съдържание)</label>
                    <InputTextarea
                      rows={7}
                      name="leafletSummary"
                      readOnly={true}
                      value={this.getImportedContentValue('leafletSummary')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label><strong>Medicine Summary</strong></label>
                    <Editor
                      style={{ width: '100%', height: '120px' }}
                      onTextChange={(e) => { this.handleChangeAdminContent('overviewSummary', e.htmlValue) }}
                      value={this.getAdminContentValue('overviewSummary')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label>Imported About</label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - точка 1)</label>
                    <InputTextarea
                      rows={7}
                      name="leafletAbout"
                      readOnly={true}
                      value={this.getImportedContentValue('leafletAbout')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label><strong>Medicine About</strong></label>
                    <Editor
                      style={{ width: '100%', height: '120px' }}
                      onTextChange={(e) => { this.handleChangeAdminContent('overviewAboutMedicine', e.htmlValue) }}
                      value={this.getAdminContentValue('overviewAboutMedicine')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label>Imported Before Intake</label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - точка 2)</label>
                    <InputTextarea
                      rows={7}
                      name="leafletBeforeIntake"
                      readOnly={true}
                      value={this.getImportedContentValue('leafletBeforeIntake')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label><strong>Medicine Before Intake</strong></label>
                    <Editor
                      style={{ width: '100%', height: '120px' }}
                      onTextChange={(e) => { this.handleChangeAdminContent('overviewBeforeIntake', e.htmlValue) }}
                      value={this.getAdminContentValue('overviewBeforeIntake')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label>Imported Dosage Content</label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - точка 3)</label>
                    <InputTextarea
                      rows={7}
                      name="leafletDosageContent"
                      readOnly={true}
                      value={this.getImportedContentValue('leafletDosageContent')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label><strong>Medicine Dosage Content</strong></label>
                    <Editor
                      style={{ width: '100%', height: '120px' }}
                      onTextChange={(e) => { this.handleChangeAdminContent('overviewDosage', e.htmlValue) }}
                      value={this.getAdminContentValue('overviewDosage')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label>Imported Side Effects</label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - точка 4)</label>
                    <InputTextarea
                      rows={7}
                      name="leafletSideEffects"
                      readOnly={true}
                      value={this.getImportedContentValue('leafletSideEffects')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label><strong>Medicine Side Effects</strong></label>
                    <Editor
                      style={{ width: '100%', height: '120px' }}
                      onTextChange={(e) => { this.handleChangeAdminContent('overviewSideEffects', e.htmlValue) }}
                      value={this.getAdminContentValue('overviewSideEffects')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label>Imported Safety Data</label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - точка 5)</label>
                    <InputTextarea
                      rows={7}
                      name="leafletSafetyData"
                      readOnly={true}
                      value={this.getImportedContentValue('leafletSafetyData')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label><strong>Medicine Safety Data</strong></label>
                    <Editor
                      style={{ width: '100%', height: '120px' }}
                      onTextChange={(e) => { this.handleChangeAdminContent('overviewSafetyData', e.htmlValue) }}
                      value={this.getAdminContentValue('overviewSafetyData')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label>Imported Additional Info</label><label style={{ color: "#dc3545" }}>&nbsp;(ЛП - точка 6)</label>
                    <InputTextarea
                      rows={7}
                      name="leafletAdditionalInfo"
                      readOnly={true}
                      value={this.getImportedContentValue('leafletAdditionalInfo')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <label><strong>Medicine Additional Info</strong></label>
                    <Editor
                      style={{ width: '100%', height: '120px' }}
                      onTextChange={(e) => { this.handleChangeAdminContent('overviewAdditionalInfo', e.htmlValue) }}
                      value={this.getAdminContentValue('overviewAdditionalInfo')}
                    />
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Clinical Data">
                <div className="p-grid p-fluid p-md-12">
                  <div className="p-col-12 p-md-12">
                    <label>Imported clinical data</label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 4)</label>
                    <InputTextarea
                      rows={7}
                      name="smPCclinicalData"
                      readOnly={true}
                      value={this.getImportedContentValue('smPCclinicalData')}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <Card title="Dosage">
                      <div className="p-fluid p-grid p-md-12">
                        <div className="p-col-12 p-md-6">
                          <label><strong>Summary</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 4.1)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeDosageContent('summary', e.htmlValue) }}
                            value={this.getDosageContentValue('summary')}
                          />
                        </div>
                        <div className="p-col-12 p-md-6">
                          <label><strong>Overdose description</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 4.9)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeDosageContent('overdoseDescription', e.htmlValue) }}
                            value={this.getDosageContentValue('overdoseDescription')}
                          />
                        </div>
                        <div className="p-col-12 p-md-6">
                          <label><strong>Dose adjustments</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 4.2)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeDosageContent('doseAdjustments', e.htmlValue) }}
                            value={this.getDosageContentValue('doseAdjustments')}
                          />
                        </div>
                        <div className="p-col-12 p-md-6">
                          <label><strong>Precautions</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 4.4)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeDosageContent('precautions', e.htmlValue) }}
                            value={this.getDosageContentValue('precautions')}
                          />
                        </div>
                      </div>
                    </Card>
                  </div>
                  <div className="p-col-12 p-md-12">
                    <Card title="Interactions">
                      <div className="p-fluid p-grid p-md-12">
                        <div className="p-col-12 p-md-12">
                          <label><strong>Description</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 4.5)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeMedicineInteractionContent('description', e.htmlValue) }}
                            value={this.getMedicineInteractionContentValue('description')}
                          />
                        </div>
                      </div>
                    </Card>
                  </div>
                  <div className="p-col-12 p-md-12">
                    <Card title="Pregnancy and breastfeeding">
                      <div className="p-fluid p-grid p-md-12">
                        <div className="p-col-12 p-md-12">
                          <label><strong>Description</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 4.6)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangePregnancyContent('pregnancyContent', e.htmlValue) }}
                            value={this.getPregnancyContentValue('pregnancyContent')}
                          />
                        </div>
                      </div>
                    </Card>
                  </div>
                  <div className="p-col-12 p-md-12">
                    <Card title="Drive and machine ">
                      <div className="p-fluid p-grid p-md-12">
                        <div className="p-col-12 p-md-12">
                          <label><strong>Description</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 4.7)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeDriveContent('driveDescription', e.htmlValue) }}
                            value={this.getDriveContentValue('driveDescription')}
                          />
                        </div>
                      </div>
                    </Card>
                  </div>
                  <div className="p-col-12 p-md-12">
                    <Card title="Side effects">
                      <div className="p-fluid p-grid p-md-12">
                        <div className="p-col-12 p-md-6">
                          <label><strong>Professional description</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 4.8)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeSideEffectContent('professionalDescription', e.htmlValue) }}
                            value={this.getSideEffectContentValue('professionalDescription')}
                          />
                        </div>
                        <div className="p-col-12 p-md-6">
                          <label><strong>Overdose description</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 4.9)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeSideEffectContent('overdoseDescription', e.htmlValue) }}
                            value={this.getSideEffectContentValue('overdoseDescription')}
                          />
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Safety Data">
                <div className="p-grid p-fluid p-md-12">
                  <div className="p-col-12 p-md-12">
                    <label>Pharmaceutical Data</label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 6)</label>
                    <InputTextarea
                      rows={7}
                      name="smPCpharmaceuticalData"
                      readOnly={true}
                      value={this.getImportedContentValue('smPCpharmaceuticalData')}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <Card title="Safety Data">
                      <div className="p-fluid p-grid p-md-12">
                        <div className="p-col-12 p-md-12">
                          <label><strong>Shelf life</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 6.3)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeSafetyDataContent('shelfLife', e.htmlValue) }}
                            value={this.getSafetyDataContentValue('shelfLife')}
                          />
                        </div>
                        <div className="p-col-12 p-md-12">
                          <label><strong>Storage place and precautions</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 6.4)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeSafetyDataContent('storagePrecautions', e.htmlValue) }}
                            value={this.getSafetyDataContentValue('storagePrecautions')}
                          />
                        </div>
                        <div className="p-col-12 p-md-12">
                          <label><strong>Product handling and disposal</strong></label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 6.6)</label>
                          <Editor
                            style={{ width: '100%', height: '120px' }}
                            onTextChange={(e) => { this.handleChangeSafetyDataContent('productDisposal', e.htmlValue) }}
                            value={this.getSafetyDataContentValue('productDisposal')}
                          />
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Files">
                <div className="p-grid p-fluid p-md-12">
                  {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}

                  <div className="p-col-12 p-md-12" style={{ marginTop: "5px" }}>
                    {/* <input type="file" onChange={(e) => this.handleOnChange(e)} style={{ display: 'none' }} ref={(el) => this.refLefletFile = el} /> */}
                    <Button
                      type="button"
                      label="Add New"
                      className="p-button-success"
                      tooltip="Add new Leaflet"
                      tooltipOptions={{ position: 'top' }}
                      // onClick={(e) => this.refLefletFile.click()}
                      style={{ width: 'auto' }}
                    />
                    <span style={{ padding: '0 10px', fontSize: ".9em", fontStyle: 'italic' }}>
                      Allowed file type is EMA ERAP medicine product file.
                    </span>
                  </div>
                  <div className="p-col-12 p-md-12">
                    <DataTable
                      value={inputMedicineFiles.filter(r => r.langId == this.state.selectedLangId)}
                    >
                      <Column field="fileName" header="Name" body={(rowData, column) =>
                        rowData.fileId ?
                          <a href={`${Constants.apiUrl}/importData/openImportedFile/${rowData.fileId}/${rowData.fileName}`} target='_blank'>{rowData.fileName}</a>
                          : rowData.fileName
                      } />
                      <Column field="fileSizeInBytes" header="Size" body={(rowData, column) => HelperFunctions.formatBytes(rowData.fileSizeInBytes, 3)} />
                      <Column field="fileSizeInBytes" header="Type"
                        body={(rowData, column) =>
                          <Dropdown
                            value={rowData.medicineLeafletTypeId ? rowData.medicineLeafletTypeId : 1}
                            options={this.state.leafletTypes}
                            //onChange={(e) => this.props.leafletTypeChange(rowData, e.value)}
                            style={{ width: '100%' }}
                          />

                        } />
                      <Column
                        header="Actions"
                        style={{ textAlign: "center", width: "8em" }}
                        body={(rowData, column) =>
                          <div>
                            <Button
                              type="button"
                              icon="pi pi-times-circle"
                              className="p-button-warning"
                              tooltip="Remove"
                              tooltipOptions={{ position: 'top' }}
                            //onClick={() => this.props.removeLeafletClick(rowData)}
                            />
                          </div>
                        }
                      />
                    </DataTable>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Other (not used)">
                <div className="p-grid p-fluid p-md-12">
                  <div className="p-col-12 p-md-12">
                    <label>Product Data</label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 1)</label>
                    <InputTextarea
                      rows={5}
                      name="smPCproductNameData"
                      readOnly={true}
                      value={this.getImportedContentValue('smPCproductNameData')}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <label>Quantitive and Qualitive Data</label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 2)</label>
                    <InputTextarea
                      rows={5}
                      name="smPCquantitiveQualitiveData"
                      readOnly={true}
                      value={this.getImportedContentValue('smPCquantitiveQualitiveData')}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <label>Medicine Form Data</label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 3)</label>
                    <InputTextarea
                      rows={5}
                      name="smPCmedicineForm"
                      readOnly={true}
                      value={this.getImportedContentValue('smPCmedicineForm')}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <label>Pharmacological Data</label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 5)</label>
                    <InputTextarea
                      rows={5}
                      name="smPCpharmacologicalData"
                      readOnly={true}
                      value={this.getImportedContentValue('smPCpharmacologicalData')}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <label>Authorisation Holder</label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 7)</label>
                    <InputTextarea
                      rows={5}
                      name="smPCauthorisationHolder"
                      readOnly={true}
                      value={this.getImportedContentValue('smPCauthorisationHolder')}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <label>Authrisation Numbers</label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 8)</label>
                    <InputTextarea
                      rows={5}
                      name="smPCauthrisationNumbers"
                      readOnly={true}
                      value={this.getImportedContentValue('smPCauthrisationNumbers')}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <label>Authorisation Dates</label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 9)</label>
                    <InputTextarea
                      rows={5}
                      name="smPCauthorisationDates"
                      readOnly={true}
                      value={this.getImportedContentValue('smPCauthorisationDates')}
                    />
                  </div>
                  <div className="p-col-12 p-md-12">
                    <label>Text Actualisation Date</label><label style={{ color: "#dc3545" }}>&nbsp;(КХП - точка 10)</label>
                    <Editor
                      style={{ width: '100%', height: '120px' }}
                      readonly={true}
                      value={this.getImportedContentValue('smPCtextActualisationDate')}
                    />
                  </div>
                </div>
              </TabPanel>
            </TabView>
          </div>
        </Dialog >

        {this.state.isVisibleInactiveAddEdit ? (
          <InactiveAddEditDialog
            saveClick={this.handleSaveInactiveButton}
            cancelClick={this.handleInactiveCancelButton}
            currentInactiveIngredient={this.state.currentInactiveIngredient}
            isVisible={this.state.isVisibleInactiveAddEdit}
          />
        ) : null}
      </>
    )
  }
}

export default ImportDataEditDialog;